
import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Messages } from '~src/codegen/Localize';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';

import { IDeleteClusterNodeResult } from '../../serverApi/requests/DeleteClusterNodeRequest';
import { BaasEdgePoolAndCluster } from '../../serverApi/resources/BaasEdgePoolAndCluster';
import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';


export function openDeleteClusterNodeDialog(actionItem: ActionItemInfo) {
  const { nodeId, clusterId, siteId, nodeName, refreshPoolsAndClusters } = actionItem;
  const dialogInstance = openReactConfirmationDialog({
    title: Messages.dataConnectSiteSettingsDeletePoolNodeButton(),
    message: Messages.dataConnectSiteSettingsDeletePoolNodeDescription({ NAME: L10n.elideIfLong(nodeName) }),
    paramsForAction: { nodeId: nodeId},
    actionName: Messages.confirm(),
    action: ({ nodeId }) => {
      return  BaasEdgePoolAndCluster.deleteClusterNode({siteId: siteId, clusterId: clusterId, nodeId: nodeId})
      .then((result: IDeleteClusterNodeResult) => {
        refreshPoolsAndClusters();
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsDeletePoolNodeSuccess({NAME: nodeName}) });
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        return Promise.resolve();
      });
    },
    isActionDelete: true,
    dialogWidth: TabDialogWidth.width375px
  });

  return Promise.resolve(dialogInstance.result);
}
